import { useState, useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';

const TESTIMONIALS = [
  { quote: 'Feral Techlabs delivered our trading dashboard in 3 weeks — half the timeline we expected. The Rust backend handles our real-time feeds without breaking a sweat.',
    author: 'Algorithmic Trader', company: 'Fintech Startup', result: '3-week delivery, sub-ms latency' },
  { quote: 'We needed 5 iOS apps for our fitness brand and thought we would need 6 months and a huge team. They shipped all 5 in 8 weeks with a shared design system that looks incredible.',
    author: 'Product Lead', company: 'Health & Fitness Brand', result: '5 apps in 8 weeks' },
  { quote: 'Their AI-augmented workflow is real — not a buzzword. The weekly demos showed tangible progress every single time. First agency experience where I never had to chase for updates.',
    author: 'Startup Founder', company: 'SaaS Platform', result: 'On-time, on-budget delivery' },
];

const Testimonials = () => {
  const [current, setCurrent] = useState(0);
  const [direction, setDirection] = useState(0);

  const next = useCallback(() => {
    setDirection(1);
    setCurrent((prev) => (prev + 1) % TESTIMONIALS.length);
  }, []);

  const prev = useCallback(() => {
    setDirection(-1);
    setCurrent((p) => (p - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 6000);
    return () => clearInterval(timer);
  }, [next]);

  const variants = {
    enter: (dir) => ({ x: dir > 0 ? 60 : -60, opacity: 0 }),
    center: { x: 0, opacity: 1 },
    exit: (dir) => ({ x: dir > 0 ? -60 : 60, opacity: 0 }),
  };
  const t = TESTIMONIALS[current];

  return (
    <section className="r-section results" id="results">
      <div className="r-wrap">
        <div className="r-tag r-reveal">Results</div>
        <h2 className="r-head r-reveal">
          What happens when <span className="r-gtxt">clients work with us.</span>
        </h2>

        <div className="tst-card r-panel r-reveal r-d1">
          <div className="tst-quoteicon"><Quote className="w-10 h-10" /></div>
          <AnimatePresence mode="wait" custom={direction}>
            <motion.div
              key={current}
              custom={direction}
              variants={variants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
            >
              <blockquote className="tst-quote">&ldquo;{t.quote}&rdquo;</blockquote>
              <div className="tst-meta">
                <div>
                  <div className="tst-author">{t.author}</div>
                  <div className="tst-company">{t.company}</div>
                </div>
                <div className="tst-result">✦ {t.result}</div>
              </div>
            </motion.div>
          </AnimatePresence>

          <div className="tst-nav">
            <div className="tst-dots">
              {TESTIMONIALS.map((item, i) => (
                <button
                  key={item.author}
                  type="button"
                  className={`tst-dot ${i === current ? 'is-on' : ''}`}
                  onClick={() => { setDirection(i > current ? 1 : -1); setCurrent(i); }}
                  aria-label={`Testimonial ${i + 1}`}
                />
              ))}
            </div>
            <div className="tst-arrows">
              <button type="button" className="tst-arrow" onClick={prev} aria-label="Previous testimonial">
                <ChevronLeft className="w-4 h-4" />
              </button>
              <button type="button" className="tst-arrow" onClick={next} aria-label="Next testimonial">
                <ChevronRight className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
